import * as React from "react";
import classnames from "classnames";
import { List } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Text } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css                              */
const ProductDetailDescription = ({
  className,
  children,
  description,
  header,
  title: propTitle,
  usps
}) => {
  const { getLabel } = useIntl();
  const title = propTitle || getLabel("products.contactLenses.header.details");
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      className: classnames("product-detail-description", className),
      "aria-label": title,
      "data-t": "product-detail-description"
    },
    /* @__PURE__ */ React.createElement(Heading, { variant: "smallest", component: "h2" }, title),
    usps && /* @__PURE__ */ React.createElement(List, { className: "product-detail-description__list", icon: "checkmark", items: usps }),
    header && /* @__PURE__ */ React.createElement(
      Heading,
      {
        variant: "subheading1",
        className: "product-detail-description__subheading",
        component: "h3"
      },
      header
    ),
    description && /* @__PURE__ */ React.createElement(Text, { spacings: ["mb-5"], variant: "body" }, description),
    children
  );
};
export {
  ProductDetailDescription
};
//# sourceMappingURL=ProductDetailDescription.js.map
